import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCalendar, faHandHoldingHand, faCheckCircle, faHome, faIdCard, faLayerGroup, faListAlt, faListCheck, faListDots, faListOl, faQrcode, faUser, faUsers, faUserTie, faHandsHoldingChild } from '@fortawesome/free-solid-svg-icons';
import './ThinkService.css';
// import thinkserviceimage from '../../assets/pageimages/thinkserviceimage.webp';

function ThinkServiceKidsHome() {
  const services = [
    { title: 'Arts Teacher', category: 'Arts Teacher', icon: 'fa-palette' },
    { title: 'Baby Sitter', category: 'Baby Sitter', icon: 'fa-baby' },
    { title: 'Kids Party Organizers', category: 'Birthday & Party Organizers', icon: 'fa-birthday-cake' },
    { title: 'Music Teacher', category: 'Music Teacher', icon: 'fa-music' },
    { title: 'Tution', category: 'Tution', icon: 'fa-chalkboard-teacher' }, 
    { title: 'Unlisted', category: 'Unlisted', icon: 'fa-question-circle' }
  ]

  return (
    <MainLayout>
      <div className="mt-12 min-h-screen py-8 bg-gradient-to-r from-blue-400 via-green-500 to-yellow-200">
        <h2 className='text-2xl font-bold text-red-500 text-center mb-2'>ThinkServiceForKids@Think5Whys</h2>
        <div className="p-4 rounded-lg flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6">
          {/* <img
            src={thinkserviceimage}
            alt="ThinkService"
            style={{width:'300px', height: 'auto'}}
            className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md"
          /> */}
          <FontAwesomeIcon icon={faHandsHoldingChild} className="text-8xl sm:text-8xl mr-3 text-purple-700" />
        </div>
        

        <div className="bg-gray-200 mb-2 p-4 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6 mt-2">
          <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faHome} className="text-2xl sm:text-2xl mr-3" />
            <span>My Account</span>
          </Link>

          <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faCalendar} className="text-2xl sm:text-2xl mr-3" />
            <span>Book A Kids Serivce</span>
          </Link>

          <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faBolt} className="text-2xl sm:text-2xl mr-3" />
            <span>Emergency Kids Service Required</span>
          </Link>

          {/* <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faCheckCircle} className="text-2xl sm:text-2xl mr-3" />
            <span>I am Available</span>
          </Link> */}

          <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faUserTie} className="text-2xl sm:text-2xl mr-3" />
            <span>Enroll as Kids Service Provider</span>
          </Link>

          <Link to={""} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faLayerGroup} className="text-2xl sm:text-2xl mr-3" />
            <span>Enroll as Partner</span>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-6 gap-2 ml-8 mr-8">
          {services.map((service, index) => (
            <Link to={`/think-service-services-list/${service.category}`} key={index}>
              <div
                className="bg-gray-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-300 transition duration-300"
              >
                <i className={`fas ${service.icon} text-2xl text-blue-500 mb-2`}></i>
                <h2 className="text-sm font-semibold break-words whitespace-normal">
                  {service.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkServiceKidsHome;



